// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"460":"8660271e","673":"a101b223"}[chunkId] + ".chunk.js";
};